(() => {
  const videoSelector =
    'product-gallery .product-gallery__media video';

  /**
   * Sørger for at produktvideoen alltid er lydløs,
   * spilles inline og aldri viser native kontroller.
   */
  function configureVideo(video) {
    if (!(video instanceof HTMLVideoElement)) {
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.removeAttribute('controls');
  }

  /**
   * Pauser og spoler en video tilbake til starten.
   */
  function resetVideo(video) {
    configureVideo(video);
    video.pause();

    const resetPosition = () => {
      try {
        video.currentTime = 0;
      } catch (error) {
        // Videoens metadata er ikke klar ennå.
      }

      configureVideo(video);
    };

    if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
      resetPosition();
    } else {
      video.addEventListener('loadedmetadata', resetPosition, {
        once: true
      });
    }
  }

  /**
   * Når brukeren forlater en video, nullstilles alle videoer
   * bortsett fra mediet brukeren er på vei til.
   */
  document.addEventListener(
    'carousel:change',
    (event) => {
      const gallery = event.target.closest('product-gallery');

      if (!gallery) {
        return;
      }

      const nextMedia = event.detail?.cell;

      gallery
        .querySelectorAll('.product-gallery__media video')
        .forEach((video) => {
          if (!nextMedia?.contains(video)) {
            resetVideo(video);
          }
        });
    },
    true
  );

  /**
   * Når videoen blir aktiv igjen, sikres autoplay uten controls.
   */
  document.addEventListener(
    'carousel:settle',
    (event) => {
      const gallery = event.target.closest('product-gallery');
      const activeVideo = event.detail?.cell?.querySelector('video');

      if (!gallery || !activeVideo) {
        return;
      }

      configureVideo(activeVideo);

      requestAnimationFrame(() => {
        configureVideo(activeVideo);

        if (activeVideo.paused) {
          activeVideo.play().catch(() => {
            // Prestige kan forsøke å legge tilbake controls ved avvist
            // autoplay. MutationObserver nedenfor fjerner dem igjen.
            configureVideo(activeVideo);
          });
        }
      });

      setTimeout(() => configureVideo(activeVideo), 150);
  },
  true
  );

  /**
   * Prestige kan dynamisk sette controls=true dersom autoplay
   * avvises. Observeren fjerner dette umiddelbart.
   */
  const controlsObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const video = mutation.target;

      if (
        video instanceof HTMLVideoElement &&
        video.matches(videoSelector)
      ) {
        configureVideo(video);
      }
    });
  });

  controlsObserver.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['controls']
  });

  document
    .querySelectorAll(videoSelector)
    .forEach(configureVideo);
})();